import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { MessageCircle, Users, Search } from "lucide-react";

export default function CommunityForum() {
  return (
    <PageContainer>
      <div className="max-w-6xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold">Community Forum</h1>
          <p className="text-xl text-gray-600">
            Connect with other Digital Human Care users, share experiences, and find solutions together.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="p-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <MessageCircle className="w-6 h-6 text-primary" />
              </div>
              <h2 className="text-xl font-semibold">Latest Discussions</h2>
              <p className="text-gray-600">Browse the most recent topics and conversations in our community.</p>
            </div>
          </Card>

          <Card className="p-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <Users className="w-6 h-6 text-primary" />
              </div>
              <h2 className="text-xl font-semibold">User Groups</h2>
              <p className="text-gray-600">Join specialized groups based on your interests and needs.</p>
            </div>
          </Card>

          <Card className="p-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <Search className="w-6 h-6 text-primary" />
              </div>
              <h2 className="text-xl font-semibold">Search Forum</h2>
              <p className="text-gray-600">Find specific topics or discussions using our search feature.</p>
            </div>
          </Card>
        </div>
      </div>
    </PageContainer>
  );
}